"use strict";

module.exports = require('../package.json').version;